<template>
    <div id="div1">
        <div class="radio" id="radio1" style="display: block;" prev="first">
            <div class="text" v-html="value"></div>
            <label @click="forYes" v-show="!finish">是</label>
            <label @click="forNo" v-show="!finish">否</label>
            <button class="finishBtn" v-show="finish" @click="close">完成</button>
        </div>
        <div class="back" v-show="back" @click="backPrev">返回</div>
    </div>
</template>
<script>
import commonData from '../../plugins/FetchCommonData/'
    export default {
        name: 'div1',
        data() {
            return {
                back: false,
                finish: false,
                showRadio: '1',
                value: '1. 是否需要编写策略公式做自动交易？',
                YesRadio: '21',
                NoRadio: '22',
                prevRadio: '',
                radio: [],
            }
        },
        methods: {
            forYes (){
                let obj = this.ObjMessage(this.YesRadio)[0];
                this.value = obj.name;
                this.YesRadio = obj.nextYes;
                this.NoRadio = obj.nextNo;
                this.prevRadio = obj.prev;
                this.showRadio = obj.id;
                if (this.showRadio == 'finish1' || this.showRadio == 'finish2' || this.showRadio == 'finish3' || this.showRadio == 'finish4') {
                    this.back = false;
                    this.finish = true;
                } else {
                    if (this.showRadio == '1') {
                        this.back = false;
                    } else {
                        this.back = true;
                    }
                    this.finish = false;
                }
            },

            forNo (){
                let obj = this.ObjMessage(this.NoRadio)[0];
                this.value = obj.name;
                this.YesRadio = obj.nextYes;
                this.NoRadio = obj.nextNo;
                this.prevRadio = obj.prev;
                this.showRadio = obj.id;
                if (this.showRadio == 'finish1' || this.showRadio == 'finish2' || this.showRadio == 'finish3' || this.showRadio == 'finish4') {
                    this.back = false;
                    this.finish = true;
                } else {
                    if (this.showRadio == '1') {
                        this.back = false;
                    } else {
                        this.back = true;
                    }
                    this.finish = false;
                }
            },

            backPrev (){
                let obj = this.ObjMessage(this.prevRadio)[0];
                this.value = obj.name;
                this.YesRadio = obj.nextYes;
                this.NoRadio = obj.nextNo;
                this.prevRadio = obj.prev;
                this.showRadio = obj.id;
                if (this.showRadio == 'finish1' || this.showRadio == 'finish2' || this.showRadio == 'finish3' || this.showRadio == 'finish4') {
                    this.back = false;
                    this.finish = true;
                } else {
                    if (this.showRadio == '1') {
                        this.back = false;
                    } else {
                        this.back = true;
                    }
                    this.finish = false;
                }
            },

            close(){

                window.parent['CloseClick']();
            },

            ObjMessage(ids){
                let xlType = this.radio.filter(obj => {
                    return obj.id == ids;
                });

                return xlType;
            }
        },
        async mounted () {
            let wt9 = await commonData('appShortName_17')
            let wt9_full = await commonData('appFullName_17')
            let wt8 = await commonData('appShortName_11')
            let wt8_full = await commonData('appFullName_11')
            let wt7 = await commonData('appShortName_12')
            let wh6 = await commonData('appShortName_10')
            this.radio = [
                {
                    name: '1. 是否需要编写策略公式做自动交易？',
                    id: '1',
                    nextYes: '21',
                    nextNo: '22',
                    prev: ''
                },
                {
                    name: '2. 是否需要通过编写算法交易公式，实现自动的拆分大单、追价、调整委托价等对下单过程进行自动的精细化控制？',
                    id: '21',
                    nextYes: 'finish1',
                    nextNo: '32',
                    prev: '1'
                },
                {
                    name: '2. 是否需要套利交易？',
                    id: '22',
                    nextYes: '33',
                    nextNo: '31',
                    prev: '1'
                },
                {
                    name: '3. 是否需要套利量化交易？',
                    id: '33',
                    nextYes: 'finish1',
                    nextNo: 'finish3',
                    prev: '22'
                },
                {
                    name: '3. 你做程序化套利交易？',
                    id: '32',
                    nextYes: 'finish1',
                    nextNo: '42',
                    prev: '21'
                },
                {
                    name: '3. 是否需要自挂牌日开始的超长历史k线数据，做技术分析？',
                    id: '31',
                    nextYes: 'finish1',
                    nextNo: '41',
                    prev: '22'
                },
                {
                    name: '4. 是否需要多账号下单？管理多个交易账号，一带多下单。',
                    id: '41',
                    nextYes: 'finish3',
                    nextNo: '51',
                    prev: '31'
                },
                {
                    name: '4. 是否需要编写公式做自动的期权交易？',
                    id: '42',
                    nextYes: 'finish1',
                    nextNo: 'finish2',
                    prev: '32'
                },
                {
                    name: '5. 是否需要使用风控单功能？电脑帮你监测盈亏、持仓、资金等数据，自动帮你平仓控制风险。',
                    id: '51',
                    nextYes: 'finish3',
                    nextNo: '61',
                    prev: '41'
                },
                {
                    name: '6. 是否需要国内交易所五档数据、国外交易所实时数据等其它数据？',
                    id: '61',
                    nextYes: 'finish3',
                    nextNo: '71',
                    prev: '51'
                },
                {
                    name: '7. 你的电脑是一台主机接连多台显示屏吗？',
                    id: '71',
                    nextYes: 'finish3',
                    nextNo: '81',
                    prev: '61'
                },
                {
                    name: '8. 是否需要进行公式选股？',
                    id: '81',
                    nextYes: 'finish3',
                    nextNo: '91',
                    prev: '71'
                },
                {
                    name: '9. 是否需要公式预警、趋势线预警？',
                    id: '91',
                    nextYes: 'finish3',
                    nextNo: '101',
                    prev: '81'
                },
                {
                    name: '10. 是否需要对不同合约/周期设置不同的个性化指标区？',
                    id: '101',
                    nextYes: 'finish3',
                    nextNo: '111',
                    prev: '91'
                },
                {
                    name: '11. 是否需要自然时间划分K线？',
                    id: '111',
                    nextYes: 'finish3',
                    nextNo: 'finish4',
                    prev: '101'
                },
                {
                    name: `<p style="text-align: center;margin-top: 10px;">你适合使用：${wt9_full}（${wt9}）<a href="https://wt9.wenhua.com.cn/" target="_blank">点击下载软件</a></p>`,
                    id: 'finish1'
                },
                {
                    name: `<p style="text-align: center;margin-top: 10px;">你适合使用：${wt8_full}（${wt8}）<a href="https://wt8.wenhua.com.cn/" target="_blank">点击下载软件</a></p>`,
                    id: 'finish2'
                },
                {
                    name: `<p style="text-align: center;margin-top: 10px;">你适合使用：睿期大户室期货交易（${wt7}）<a href="https://rich.wenhua.com.cn/" target="_blank">点击下载软件</a></p>`,
                    id: 'finish3'
                },
                {
                    name: `<p style="text-align: center;margin-top: 10px;">你适合使用：期货行情交易（${wh6}）<a href="https://wh6.wenhua.com.cn/" target="_blank">点击下载软件</a></p>`,
                    id: 'finish4'
                },
            ]
        }
    }
</script>
<style scoped>
    #div1{
        width: 476px;
        height: 186px;
        background: url('~@/assets/image/bg_red.png') no-repeat;
        padding: 85px 74px 0 92px;
        position: relative;
    }

    #div1 .text{
        font-size: 18px;
        line-height: 31px;
        color: rgb(56, 5, 5);
        padding-left: 20px;
        text-indent: -20px;
        margin: 0;
    }

    #div1 .text a{
        color: #5276f9;
        font-size: 15px;
        text-decoration: underline;
    }

    label {
        height: 29px;
        line-height: 29px;
        width: 80px;
        border-radius: 18px;
        font-size: 17px;
        border: 1px solid rgb(135, 33, 33);
        background: rgb(255, 249, 249);
        color: rgb(116, 0, 0);
        text-align: center;
        cursor: pointer;
        position: absolute;
        bottom: 80px;
    }

    label:first-of-type {
        left: 200px;
    }

    label:last-of-type {
        right: 200px;
    }

    .back {
        position: absolute;
        font-size: 15px;
        border-bottom: 1px solid rgb(116, 0, 0);
        color: rgb(116, 0, 0);
        height: 18px;
        width: 33px;
        right: 92px;
        bottom: 72px;
        cursor: pointer;
    }

    
    .back::before {
        content: '';
        width: 13px;
        height: 14px;
        position: absolute;
        left: -14px;
        top: 3px;
        background: url("~@/assets/image/fh_red.png") no-repeat;

    }

    .finishBtn {
        height: 29px;
        line-height: 27px;
        width: 109px;
        border-radius: 14px;
        border: 1px solid rgb(135, 33, 33);
        background: rgb(255, 249, 249);
        color: rgb(116, 0, 0);
        text-align: center;
        cursor: pointer;
        position: absolute;
        bottom: 80px;
        left: 270px;
        letter-spacing: 5px;
        outline: none;
    }
</style>